import React, { useEffect, useState } from "react";
import NotificationDrawer from "./NotificationDrawer";
import { useSelector, useDispatch } from "react-redux";
import { AppDispatch, RootState } from "../../../redux/Store";
import { fetchNotificationCount } from "../../../redux/slice/NotificationSlice";

const NotificationIcon: React.FC = () => {
  const [showDrawer, setShowDrawer] = useState(false);
  const dispatch = useDispatch<AppDispatch>();
  const loggedInUserid = useSelector((state: RootState) => state.auth.userid);
  const notificationCount = useSelector(
    (state: RootState) => state.notifications.count,
  );

  useEffect(() => {
    if (loggedInUserid) {
      dispatch(fetchNotificationCount(loggedInUserid));
    }
  }, [loggedInUserid, dispatch]);

  const toggleDrawer = () => {
    setShowDrawer((prev) => !prev);

    // Fetch fresh count when closing drawer
    if (showDrawer && loggedInUserid) {
      dispatch(fetchNotificationCount(loggedInUserid));
    }
  };

  return (
    <>
      <div
        className="notification-icon position-relative"
        onClick={toggleDrawer}
      >
        <span className="material-icons filled-icon theme-color">
          notifications
        </span>

        {notificationCount > 0 && (
          <span className="notification-badge-header">
            {notificationCount >= 100 ? "99+" : notificationCount}
          </span>
        )}
      </div>

      <NotificationDrawer show={showDrawer} handleClose={toggleDrawer} />
    </>
  );
};

export default NotificationIcon;
